var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_9829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2533 10.8758L11.4856 12.6436L16.4824 17.6404L18.2502 15.8726L13.2533 10.8758Z",
    fill: "#847848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 8.3335C16.1917 8.3335 17.5 7.02516 17.5 5.41683C17.5 4.9335 17.3667 4.4835 17.1583 4.0835L14.9083 6.3335L13.6667 5.09183L15.9167 2.84183C15.5167 2.6335 15.0667 2.50016 14.5833 2.50016C12.975 2.50016 11.6667 3.8085 11.6667 5.41683C11.6667 5.7585 11.7333 6.0835 11.8417 6.3835L10.3 7.92516L8.81667 6.44183L9.40833 5.85016L8.23333 4.67516L10 2.9085C9.025 1.9335 7.44167 1.9335 6.46667 2.9085L3.51667 5.8585L4.69167 7.0335H2.34167L1.75 7.62516L4.7 10.5752L5.29167 9.9835V7.62516L6.46667 8.80016L7.05833 8.2085L8.54167 9.69183L2.36667 15.8668L4.13333 17.6335L13.6167 8.1585C13.9167 8.26683 14.2417 8.3335 14.5833 8.3335Z",
    fill: "#847848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_9829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.e900148fd701d0d79ca535086233f540.svg";
export { ForwardRef as ReactComponent };